import client from "@/utils/axios";

export default {
  namespaced: true,

  actions: {
    async createVerification(_, payload) {
      return client.post('/api/detelio/verification', payload);
    },
  },
};